import { BrandCreate } from 'components/product/brand-create/BrandCreate'
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useFetch } from 'services/useFetch'
import { API_BRAND } from 'services/apiBrand'
import { constructOptionMultipleSelect, convertErrorMessage, uploadFileToS3 } from 'utils/utils'
import { Alert } from 'avo-ui'
import {
    INITIAL_STATE,
    GET_FIELD_NAME,
    FIELD_NAME_DETAIL,
    ITEM_FIELD_NAME_DETAIL,
} from 'configs/product/configFormBrand'

export const BrandCreateContainer = () => {
    const navigate = useNavigate()
    const [brandDetail, setBrandDetail] = useState({})
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const [searchParams] = useSearchParams()
    const brandId = searchParams.get('brandId')
    const { fetching: getBrandDetail, isLoading } = useFetch(API_BRAND.DETAIL)
    const { fetching: getUrlBrandImages } = useFetch(API_BRAND.URL_BRAND_IMAGES)
    const { fetching: createBrand, isLoading: isCreating } = useFetch(API_BRAND.CREATE)
    const { fetching: updateBrand, isLoading: isUpdating } = useFetch(API_BRAND.UPDATE)
    const [errorForm, setErrorForm] = useState({})

    const onChangeForm = (item) => {
        setBrandDetail({ ...brandDetail, ...item })
    }

    const validateForm = () => {
        const validatePromotionBanner = () => {
            const result = []
            brandDetail?.promotion_banners?.map((item, index) => {
                if (!item?.desktop_image_url) {
                    result.push({ index, key: 'desktop_image_url', message: 'Banner desktop wajib diisi' })
                }

                if (!item?.mobile_image_url) {
                    result.push({ index, key: 'mobile_image_url', message: 'Banner mobile wajib diisi' })
                }
            })

            return result
        }

        return new Promise((resolve, reject) => {
            const errors = {}
            Object.keys(brandDetail).forEach((key) => {
                if (GET_FIELD_NAME[key] && !brandDetail[key]) {
                    errors[key] = `${GET_FIELD_NAME[key]} wajib diisi`
                } else if (key === 'promotion_banners' && validatePromotionBanner()?.length) {
                    errors['promotion_banners_detail'] = validatePromotionBanner()
                }
            })
            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const setShowAlert = (message) => {
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const setUploadBrandImages = async (filesName, uploadDetail) => {
        let newLogo = brandDetail?.image_url
        const newPromotionBanner = [...brandDetail?.promotion_banners]

        try {
            const s3Urls = await getUrlBrandImages({ files: filesName })
            const apiS3list = s3Urls?.data?.map(async (item, i) => {
                await uploadFileToS3(item, uploadDetail[i]?.file)
                if (uploadDetail[i]?.type === 'banner') {
                    newPromotionBanner[uploadDetail[i]?.index] = {
                        ...newPromotionBanner[uploadDetail[i]?.index],
                        [uploadDetail[i]?.key]: `${item?.url}${item?.fields?.key}`,
                    }
                } else {
                    newLogo = `${item?.url}${item?.fields?.key}`
                }
            })
            await Promise.all(apiS3list)
            const newDetail = {
                ...brandDetail,
                image_url: newLogo,
                promotion_banners: newPromotionBanner,
            }
            onSave(newDetail)
        } catch (err) {
            console.log('upload failed')
        }

        setIsLoadingUpload(false)
    }

    const onSubmit = () => {
        validateForm().then(async () => {
            const brandImages = [brandDetail?.image_url, ...brandDetail?.promotion_banners]
            const uploadDetail = []
            const filesName = []

            const mapBannerImages = (name, file, index, key, type = 'banner') => {
                filesName.push(name?.replace(/\s/g, ''))
                uploadDetail.push({ file, type, key, index })
            }

            brandImages.map((item, index) => {
                if (item?.name) {
                    mapBannerImages(item?.name, item?.file, 0, 'image_url', 'logo')
                }

                if (item?.desktop_image_url?.name) {
                    mapBannerImages(
                        item?.desktop_image_url?.name,
                        item?.desktop_image_url?.file,
                        index - 1,
                        'desktop_image_url',
                    )
                }

                if (item?.mobile_image_url?.name) {
                    mapBannerImages(
                        item?.mobile_image_url?.name,
                        item?.mobile_image_url?.file,
                        index - 1,
                        'mobile_image_url',
                    )
                }
            })

            if (filesName.length) {
                setIsLoadingUpload(true)
                await setUploadBrandImages(filesName, uploadDetail)
            } else {
                onSave()
            }
        })
    }

    const onSave = (payload = { ...brandDetail }) => {
        const newPayload = {
            ...payload,
            promotion_banners: payload?.promotion_banners?.map((item, index) => {
                return {
                    ...item,
                    sequence: index,
                }
            }),
        }

        if (!brandId) {
            createBrand(newPayload)
                .then(() => {
                    setShowAlert('Brand Created !')
                    navigate('/product/brand-list')
                })
                .catch((error) =>
                    setErrorForm(convertErrorMessage(error?.data, FIELD_NAME_DETAIL, ITEM_FIELD_NAME_DETAIL)),
                )
        } else {
            const newUpdatePayload = {
                ...newPayload,
                promotion_product_ids: newPayload?.promotion_product_ids?.map((i) => i?.value),
            }

            updateBrand(newUpdatePayload, brandId)
                .then(() => {
                    setShowAlert('Brand Updated !')
                    navigate('/product/brand-list')
                })
                .catch((error) =>
                    setErrorForm(convertErrorMessage(error?.data, FIELD_NAME_DETAIL, ITEM_FIELD_NAME_DETAIL)),
                )
        }
    }

    useEffect(() => {
        if (brandId) {
            getBrandDetail({}, brandId).then((response) => {
                const { image_alt_text, products, banners, slug, status, ...data } = { ...response?.data }
                const newDetail = {
                    ...data,
                    promotion_banners: banners?.map((i) => {
                        return { ...i, banner_id: i?.id }
                    }),
                    promotion_product_ids: constructOptionMultipleSelect(products, 'name', 'id', 'product_image_url'),
                }
                setBrandDetail(newDetail)
            })
        } else {
            setBrandDetail(INITIAL_STATE)
        }
        setErrorForm({})
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [brandId])

    const props = {
        sectionProps: {
            brandDetail,
            onChangeForm,
            errorForm,
            id: brandId,
        },
        isUpdate: brandId,
        isLoading,
        isLoadingUpload,
        isCreating,
        isUpdating,
        onSubmit,
    }

    return <BrandCreate {...props} />
}
